// We only currently have one export, but may be more
/* eslint import/prefer-default-export: "off" */
export const devEnabled = state => state.dev.enabled;
